import {LocalDate, LocalDateTime, Instant, ChronoUnit,ZoneOffset,DateTimeFormatter} from "@js-joda/core";

/**
 * Convert date or datetime value from model such as domain object attribute to Date.
 * 
 * @param {Date|string} value date or datetime model value. if date is already Date, then return it w/o conversion.
 *         If date is string, then it is one of the following formats:
 *         <ol>
 *            <li> YYYY-MM-DD: local DATE of browser default timezone
 *            <li> YYYY-MM-DDTHH:MI:SS: local DATETIME of browser default timezone
 *            <li> YYYY-MM-DDTHH:MI:SS.sssZ: UTC date time
 *         </ol>
 * @returns {Date} returns null if value does not have value
 */
export function modelValueToDate(value:Date|string){
    let dateValue = null;
    
    /*
     * DATE has local date format YYYY-MM-DD. DATETIME has local date time format YYYY-MM-DDTHH:MI:SS.
     * 
     * DateTimePicker does not support time zone for now. let's use browser default timezone for now to display date time.
     */
    if(value){
      if(value instanceof Date){ // in case ...
        dateValue = value;
      }else if(typeof value === 'string'){
        if(value.length == 'YYYY-MM-DD'.length){
            // support AD page which sometimes mixes DATE and DATETIME
            let localDatetime = LocalDate.parse(value).atTime(0,0,0,0);
            let zoneOffset = ZoneOffset.ofTotalMinutes(-(new Date().getTimezoneOffset()));
            dateValue = new Date(localDatetime.toEpochSecond(zoneOffset)*1000);
        }else if(value.length == 'YYYY-MM-DDTHH:MI:SS'.length){
            let localDatetime = LocalDateTime.parse(value);
            let zoneOffset = ZoneOffset.ofTotalMinutes(-(new Date().getTimezoneOffset()));
            dateValue = new Date(localDatetime.toEpochSecond(zoneOffset)*1000);
        }else if(value.length == 'YYYY-MM-DDTHH:MI:SS.sssZ'.length){ // in case ...
            dateValue = new Date(value);
        }
      }
    }

    return dateValue;
}

/**
 * convert a Date value to local datetime string.
 * 
 * @param {Date} date
 * @returns {string} local date time string of format YYYY-MM-DDTHH:MI:SS in browser default time zone. 
 */
export function dateToLocalDateTimeStr(date:Date){
    let instant = Instant.ofEpochMilli(date.getTime());
    let localDatetime = LocalDateTime.ofInstant(instant).truncatedTo(ChronoUnit.SECONDS);
    let localDatetimeStr = localDatetime.format(DateTimeFormatter.ofPattern("yyyy-MM-dd'T'HH:mm:ss"));
    return localDatetimeStr;    
}

/**
 * convert a Date value to local date string.
 * @param {Date} date 
 * @returns {string} local date string of format YYYY-MM-DD in browser default time zone.
 */
export function dateToLocalDateStr(date:Date){
    let instant = Instant.ofEpochMilli(date.getTime());
    let localDate = LocalDate.ofInstant(instant);
    return localDate.toString();    
}